import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewComplainList from "./viewComplainList";
import {
  fetchComplainList,
} from "services/redux/fileComplain/action"

import {getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
    complainList: state.fileComplainReducer.fetchComplain,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    fetchComplainList,
    getRmTicketsFilterDropDown,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewComplainList);
